module.exports = __webpack_public_path__ + "img/img81.d00f4323.png";